<template>
  <v-container fluid fill-height class="pa-0">
    <v-layout column>
      <v-autocomplete
        placeholder="Cautare"
        hint="id scara/asoc, adresa scara/asoc, obs"
        clearable
        persistent-hint
        append-icon="mdi-magnify"
        solo
        :loading="loading"
        single-line
        :suffix="String(total)"
        dense
        return-object
        :items="filteredItems"
        item-text="id_scara"
        item-value="_id"
        :search-input.sync="search"
        no-filter
        v-model="selectedItem">
        <template v-slot:selection="data">
          <v-avatar size="16">
            <v-img :src="getIcon(data.item)" height="16" contain/>
          </v-avatar>
          &nbsp;
          {{data.item.id_scara}}
        </template>
        <template v-slot:item="data">
          <v-list-tile-avatar size="22">
            <v-img :src="getIcon(data.item)" height="22" contain/>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title v-html="data.item.id_scara"></v-list-tile-title>
            <v-list-tile-sub-title>{{data.item.user || 'neatribuit'}} - {{data.item.photos.length}} poze</v-list-tile-sub-title>
          </v-list-tile-content>
        </template>
      </v-autocomplete>
      <GmapMap
        :center="mapCenter"
        :zoom="zoom"
        :map-type-id="mapType"
        :style="{ width: options.width, height: options.height }"
        ref="map"
        @center_changed="centerChanged"
        @zoom_changed="zoomChanged"
        @maptypeid_changed="mapTypeChanged">

        <!-- <GmapMarker
          :position="currentPosition"
          :label="{ text: user.username, color: labelColor, fontWeight: 'bold' }"
          :icon="{ url: '/logo.png', labelOrigin: { x: 24 / 2, y: 24 + 12 } }"
          :draggable="false"/> -->

        <template v-if="objectsOnMap.includes('users')">
          <GmapMarker
            v-for="location of usersLocations"
            :key="location.id"
            :position="location.position"
            :label="{ text: location.username, color: labelColor, fontWeight: 'bold' }"
            :icon="{ url: `${url}/svg/${location.username}-logo.png`, labelOrigin: { x: 48 / 2, y: 48 + 12 } }"
            :draggable="false"/>
        </template>

        <gmap-cluster :max-zoom="grouping === 'true' ? 22 : 1" v-if="objectsOnMap.includes('markers')">
          <GmapMarker
            v-for="(item, index) in items"
            :key="index"
            :position="{lat: Number(item.centru_geometric.lat), lng: Number(item.centru_geometric.lng)}"
            :clickable="true"
            :icon="{
              url: getIcon(item),
              labelOrigin: { x: 15, y: 56 },
              size: markerSize,
              scaledSize: markerScale
            }"
            :label="getLabel(item)"
            :draggable="false"
            @click="navigate(item)"
            :animation="user.admin && ((activeEntity && activeEntity === item._id) || (selectedItem && selectedItem._id === item._id))  ? 1 : null"/>
        </gmap-cluster>
      </GmapMap>
    </v-layout>

    <v-btn
      absolute
      small
      fab
      bottom
      left
      color="primary"
      style="bottom: 34px; left: 64px"
      @click="settings = true">
      <v-icon>mdi-cogs</v-icon>
    </v-btn>

    <v-dialog v-model="settings" persistent max-width="80vw" :transition="false" no-click-animation hide-overlay>
      <v-card flat>
        <v-card-title>Setari harta</v-card-title>
        <v-card-text style="text-align: center; max-height: 75vh; overflow: auto">
          <v-alert type="info" :value="true" style="text-align: left">
            Grupare markere / simboluri / pinuri / whatever we call them. Face harta mai usor navigabila, dar grupeaza simbolurile pe arii de proximitate.
          </v-alert>
          <v-btn @click="toggleGrouping" color="primary">
            Grupare: {{ grouping === 'true' ? 'on' : 'off' }}
            <v-icon small right>{{ grouping === 'true' ? 'mdi-circle-multiple' : 'mdi-map-marker' }}</v-icon>
          </v-btn>

          <v-alert type="info" :value="true" style="text-align: left">
            Afisare etichete markere / simboluri / pinuri / whatever we call them. Cand etichetele sunt vizibile si exista multe markere pe harta => se misca execrabil. Use with caution when on mobile.
          </v-alert>
          <v-btn @click="toggleLabels" color="primary">
            Etichete: {{ showLabels === 'true' ? 'on' : 'off' }}
            <v-icon small right>{{ showLabels === 'true' ? 'mdi-label' : 'mdi-label-off' }}</v-icon>
          </v-btn>

          <v-alert type="info" :value="true" style="text-align: left">
            Dimensiune imagini markere / simboluri / pinuri / whatever we call them. Imaginea by default are dimensiunile 20x32px. Aceste valori se inmultesc cu ce scriem aici.
          </v-alert>
          <v-text-field
            :value="iconScale"
            @input="setTempScale"
            label="Scala imagini"
            type="number"
            step="0.1"
            append-outer-icon="mdi-send"
            @click:append-outer="applyNewScale">
          </v-text-field>

          <v-alert type="info" :value="true" style="text-align: left">
            Chestii de afisat pe harta.
          </v-alert>
          <v-radio-group v-model="objectsOnMap" row>
            <v-radio label="Utilizatori" value="users"></v-radio>
            <v-radio label="Markere / Pinuri" value="markers"></v-radio>
            <v-radio label="Why not both?" value="users_and_markers"></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="settings = false">Inchide</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'
import debounce from 'lodash.debounce'
import SERVER_URL from '@/config'

// import isEqual from 'lodash.isequal'

export default {
  name: 'entity-map',
  props: {
    entity: {
      type: String,
      required: false
    }
  },
  computed: {
    google: gmapApi,
    currentPosition () {
      return this.$store.getters.currentPosition
    },
    loading () {
      return this.$store.getters.loading
    },
    mapCenter () {
      return this.$store.getters.mapCenter
    },
    zoom () {
      return this.$store.getters.zoom
    },
    mapType () {
      return this.$store.getters.mapType
    },
    total () {
      return this.filteredItems.length
    },
    activeEntity () {
      return this.$route.params.entity
    },
    user () {
      return this.$store.getters.user
    },
    items () {
      return this.$store.getters['entities/allItems']
    },
    grouping () {
      return this.$store.getters['entities/grouping']
    },
    showLabels () {
      return this.$store.getters['entities/showLabels']
    },
    iconScale: {
      get () {
        return Number(this.$store.getters['entities/iconScale']) || 1
      },
      set (value) {
        this.$store.commit('entities/setIconScale', value)
      }
    },
    usersLocations () {
      return this.$store.getters.usersLocations
    },
    objectsOnMap: {
      get () {
        return this.$store.getters['entities/objectsOnMap']
      },
      set (value) {
        this.$store.commit('entities/setObjectsOnMap', value)
      }
    }
  },
  watch: {
    google: {
      immediate: true,
      handler (g) {
        if (g) {
          this.markerSize = new g.maps.Size(20 * this.iconScale, 32 * this.iconScale) // gets ignored
          this.markerScale = new g.maps.Size(20 * this.iconScale, 32 * this.iconScale) // gets ignored
        }
      }
    },
    selectedItem (v) {
      if (v) {
        this.$refs.map.$mapPromise.then((map) => {
          map.panTo({ lat: Number(v.centru_geometric.lat), lng: Number(v.centru_geometric.lng) })
          map.setZoom(19)
        })
      }
    },
    search: {
      immediate: false,
      handler: debounce(function (v) {
        this.queryItems(v)
      }, 1000)
    },
    items: {
      immediate: true,
      handler (v) {
        this.filteredItems = v
      }
    },
    iconScale (v) {
      this.markerSize = new this.google.maps.Size(20 * v, 32 * v) // gets ignored
      this.markerScale = new this.google.maps.Size(20 * v, 32 * v) // gets ignored
    }
  },
  data: () => ({
    tempScale: 1,
    settings: false,
    url: SERVER_URL,
    search: null,
    options: {
      width: '100%',
      height: '100%'
    },
    // items: [],
    filteredItems: [],
    labelColor: 'white',
    markerSize: null,
    markerScale: null,
    selectedItem: null
  }),
  methods: {
    setTempScale ($event) {
      this.tempScale = $event
    },
    applyNewScale ($event) {
      this.iconScale = this.tempScale
    },
    queryItems (search) {
      this.filteredItems = search ? this.items.filter(item => this.filter(item, search, item.id_scara) || this.filter(item, search, item.adresa) || this.filter(item, search, item.observatii_scara)) : this.items
    },
    filter (item, search, value) {
      return value ? value.toLowerCase().includes(search.toLowerCase()) : false
    },
    centerChanged: debounce(function ($event) {
      const mapCenter = { lat: $event.lat(), lng: $event.lng() }
      this.$store.commit('setMapCenter', mapCenter)
    }, 1000),
    zoomChanged: debounce(function ($event) {
      this.$store.commit('setZoom', $event)
    }, 1000),
    mapTypeChanged ($event) {
      // if ($event === 'roadmap' || $event === 'terrain') this.labelColor = 'black'
      // else this.labelColor = 'white'
      this.$store.commit('setMapType', $event)
    },
    getIcon (marker) {
      // if (marker.addedBy) {
      //   if (marker.done) return '/svg/pin_done_people.svg'
      //   return marker.user ? '/svg/pin_edited_people.svg' : '/svg/pin_unedited_people.svg'
      // } else {
      //   if (marker.done) return '/svg/pin_done.svg'
      //   return marker.user ? '/svg/pin_edited.svg' : '/svg/pin_unedited.svg'
      // }

      if (marker.user) {
        if (marker.repozare === 'Da') return `${this.url}/svg/${marker.user}-repozare.png`
        return marker.done ? `${this.url}/svg/${marker.user}-done.png` : `${this.url}/svg/${marker.user}-edited.png`
      }

      return `${this.url}/svg/default.png`
    },
    getLabel (marker) {
      if (this.mapType === 'roadmap' || this.mapType === 'terrain') this.labelColor = 'black'
      else this.labelColor = 'white'
      // return { text: String(`${marker.id_scara} (${marker.photos.length}) ${marker.adresa}`), color: this.labelColor, fontWeight: 'bold' }
      if (this.showLabels === 'true') return { text: String(`${marker.id_scara}`), color: this.labelColor, fontWeight: 'bold' }
      return null
    },
    navigate (marker) {
      this.$router.push({ name: 'details', params: { entity: marker._id } })
    },
    toggleGrouping () {
      this.$store.commit('entities/toggleGrouping')
    },
    toggleLabels () {
      this.$store.commit('entities/toggleLabels')
    }
  },
  mounted () {
    this.$store.dispatch('fetchAllUserLocations')
    // this.$store.commit('setLoading', true)
    // this.$store.dispatch('entities/fetchAllEntities')
    //   .then(items => {
    //     // this.$store.commit('setLoading', false)
    //     this.items = items
    //     this.filteredItems = items
    //   })
    //   .catch(err => {
    //     // this.$store.commit('setLoading', false)
    //     console.log(err)
    //   })
  }
}
</script>

<style>

</style>
